import { atom } from 'jotai';

import type { ISort } from '@/ui/table/table.types';

import type { ProjectListingsDisplayMode } from './project-listings/project-listings';
import { type ProjectCompaniesSort } from '@/api/v4/projects.api';
import { atomWithStorage } from 'jotai/utils';

export const defaultProjectListingSort: ISort<ProjectCompaniesSort> = {
  sort: 'createdDate',
  direction: 'desc',
};

export const projectListingSortState = atom<ISort<ProjectCompaniesSort>>({
  sort: 'createdDate',
  direction: 'desc',
});

export const projectListingsDisplayModeState = atomWithStorage<
  Record<string, ProjectListingsDisplayMode>
>('projectListingsDisplayModeState', {});

export const createDisplayModeKey = (
  userId: string,
  projectId: string,
): string => {
  return `${userId}:${projectId}`;
};
